import React, { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';

const Landing = () => {
  return <div>Landing Page</div>;
};
export default Landing;
